module.exports = __webpack_public_path__ + "static/media/7.188aa638.png";